<template>
  <div class="title bg-success">Empresas Noc</div>
  <fieldset v-if="user">
    <table class="table table-sm">
      <thead class="table-light">
        <tr>
          <th scope="col" class="col-id">ID</th>
          <th scope="col" class="col-site">Empresa</th>
          <th scope="col" class="col-site">Telefone</th>
          <th scope="col" class="col-site">Email</th>
          <th scope="col" class="col-actions">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="site in companies" :key="site.id">
          <td style="vertical-align: middle;">{{ site.id }}</td>
          <td style="vertical-align: middle;">
            {{ site.name }}
          </td>
          <td style="vertical-align: middle;">
            {{ site.phone }}
          </td>
          <td style="vertical-align: middle;">
            {{ site.email }}
          </td>
          <td class="text-center" style="vertical-align: middle;">
            <div class="d-flex gap-1">
              <router-link v-if="isAdmin(user)" :to="`/empresas/${site.id}?mode=edit`">
                <a type="button" class="actions btn btn-secondary btn-sm">
                  Editar
                </a>
              </router-link>
              <router-link v-if="!isAdmin(user)" :to="`/empresas/${site.id}?mode=view`">
                <a type="button" class="actions btn btn-info btn-sm">
                  Visualizar
                </a>
              </router-link>
              <a v-if="isAdmin(user)" @click="()=> isDeleteModalOpened = true" type="button" class="actions btn btn-danger btn-sm">
                Excluir
              </a>
              <ModalContent 
              :is-modal-open="isDeleteModalOpened" 
              @close="() => isDeleteModalOpened = false" 
              @send="deleteCompany(site)" 
              :title="`Excluir empresa ?`">Você tem certeza que deseja excluir essa empresa ?
             </ModalContent>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    

    <button v-if="isMetroUser(user) && isAdmin(user)" @click="addCompany" type="button" class="mx-auto actions btn btn-primary btn-sm">
      Adicionar
    </button>
  </fieldset>
</template>

<script lang="ts" setup>
    import ModalContent from '@/components/ModalContent.vue';
    import { CompanyService} from '@/services/backend/ApiService';
    import UserService from '@/services/OnlineUserService'
    import router from '@/router';
    import { isAdmin, isMetroUser } from '../../../../zabbix-shared/utils/user';
    import { onMounted, ref } from 'vue';
    import { ICompany } from '../../../../zabbix-shared/interfaces/intefaces';
    
    let user = ref();
    const companies = ref<ICompany[]>([]);
    const isDeleteModalOpened = ref(false);

    const addCompany = async () => {
      let newCompany: ICompany = {} as ICompany;
      newCompany = await CompanyService.create(newCompany);
      companies.value.push(newCompany);
    };

    const deleteCompany = async (company: ICompany) => {
      try {
        isDeleteModalOpened.value = false;
        await CompanyService.delete(company.id);
        companies.value = companies.value.filter(site => site.id !== company.id);
      } catch (error) {
        console.error('Erro ao excluir a empresa:', error);
      }
    };

    const closeModal = async () => {
      isDeleteModalOpened.value = false;
    };

    const saveChanges = async () => {
      try {
        console.log('Salvando mudanças...');
      } catch (error) {
        console.error('Erro ao salvar as mudanças:', error);
      }
    };

    onMounted(async () => {
      companies.value = await CompanyService.findAll();
      user.value = await UserService.waitForUser();
      if (!isMetroUser(user.value)) {
        router.push("empresas/" + user.value.company.id);
      }
    });
</script>

<style scoped>
.col-actions {
  width: 150px;
}
</style>
